<template>
  <div class="no-service">
    <div class="card">
      <img src="../../assets/login-fail.png" />
      <div class="title">无可用服务</div>
      <div class="info">未购买服务或服务已用完</div>
      <div class="fill"></div>
      <button @click="gotoCard">返回我的无忧卡</button>
      <div class="agreement" @click="gotoAgreement">查看详细服务条款</div>
    </div>
  </div>
</template>

<script>
// import { getAgreementUrl } from '../../scripts/care_agreement';
export default {
  name: "NoService",
  created() {
    this.id = this.$route.params.id;
  },
  methods: {
    gotoCard(){
        this.$router.go(-2)
    },
    async gotoAgreement() {
    //  this.$loading.show("请稍等")
    //   const url = await getAgreementUrl(this.id,null,null)
    //   this.$loading.hide()
    //   this.goto(url)
      this.goto(`/agreement?id=${this.id}`);
    }
  }
};
</script>
<style lang="less" scoped>
.no-service {
  height: 100vh;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #efefef;
  .card {
    width: 100%;
    min-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    border-radius: 10px;
    font-weight: 500;
    padding: 16px;
    box-sizing: border-box;
    img {
      height: 104px;
      margin-top: 140px;
    }
    .title {
      font-size: 16px;
      color: black;
    }
    .info {
      font-size: 14px;
      color: #666666;
    }
    .fill {
      flex: 1 1;
    }
    button {
      width: 100%;
      text-align: center;
      color: white;
      font-size: 16px;
      line-height: 34px;
      height: 34px;
      border: none;
      margin: 16px 0;

      background: linear-gradient(
        86deg,
        rgba(224, 172, 119, 1) 0%,
        rgba(186, 136, 89, 1) 100%
      );
      border-radius: 17px;
    }

    button:active {
      background: linear-gradient(
        86deg,
        rgb(230, 165, 101) 0%,
        rgb(212, 114, 22) 100%
      );
    }
  }
  .agreement {
      font-size: 10px;
      color: #333333;
      text-align: center;
      padding: 8px;
    }
}
</style>